import React from 'react';
import { techStack } from '../../data/siteData';
import './TechStack.css';

const doubled = [...techStack, ...techStack];

export default function TechStack() {
  return (
    <section className="tech-sec">
      <div className="page-wrap center" style={{ marginBottom: 40, padding: '0 48px' }}>
        <h2 className="tech-sec-title">
          Technologies We <span className="orange-highlight">Master</span>
        </h2>
      </div>
      <div className="marquee-wrap">
        <div className="marquee-track">
          {doubled.map((t, i) => (
            <div key={i} className="tech-chip">
              <span className="tech-em">{t.icon}</span>
              <span className="tech-nm">{t.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}